var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDownArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 6,
  viewBox: "0 0 11 6",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.711704 0H9.86557C10.4988 0 10.8155 0.764898 10.3672 1.21316L5.79205 5.79188C5.51455 6.06937 5.06273 6.06937 4.78523 5.79188L0.210073 1.21316C-0.238192 0.764898 0.0784396 0 0.711704 0Z",
  fill: "black"
})));
export default __webpack_public_path__ + "static/media/Down_Arrow.9dfe7cfe.svg";
export { SvgDownArrow as ReactComponent };